const SELLER_CATEGORY_TYPE = {
    ALL: 0,
    ALL_CHANNEL: 1,
    TEAM: 2,
    AGENTS: 3,
    OTA: 4,
    OTHERS: 5,
}

export { SELLER_CATEGORY_TYPE }
export default SELLER_CATEGORY_TYPE



// WEBPACK FOOTER //
// ./src/enums/sellerCategoryType.js